import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ComplaintDetail from '../components/complaints/complaint-detail'
import dataLoad from '../actions/data-load';
import complaintDetailReset from '../actions/complaint-detail-reset';
import addComplaintFeedback from '../actions/add-complaint-feedback';

function mapStateToProps(state) {
    console.log("state are >>>>>", state)
  return {
    user: state.user,
    detailLoadStatus: state.ajaxStatuses.dataLoad.complaintDetail,
    complaint: state.complaintDetail,
    addFeedbackStatuses: state.ajaxStatuses.addFeedback,
    complaintYear: state.complaintYear,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    dataLoad,
    complaintDetailReset,
    addComplaintFeedback,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ComplaintDetail);
